/**
 * Returns the application block as a HTML string
 *
 * @param data The data object for this template
 */
export function applicationBlock(data: ApplicationBlockData): string {
    return `
        <div class="o-layout__item u-6/12@tablet c-applications__item js-fade-slide-up__item js-applications-item">
            <div class="c-application-block c-application-block--${ data.block_type } js-application-block js-fade-slide-up__item">

                <div class="c-application-block__media">
                    <p class="c-application-block__logo-mark"><svg width="40" height="40"><use xlink:href="#svg-logo-mark"></svg></p>

                    <div class="c-application-block__gallery o-flickity js-application-block__gallery" data-flickity='${ data.gallery_settings }'>
                        ${ data.gallery.map(item => `
                            <div class="c-application-block__slide o-flickity__slide">
                                <a href="${ data.permalink }"><img class="o-bg u-fill" src="${ item.src }" alt="${ item.alt }" srcset="${ item.srcset }" sizes="(min-width: 740px) 50vw, (min-width: 1300px) 530px, 100vw" /></a>
                            </div>
                        `).join('')}
                    </div>

                    <p class="c-application-block__cta ${ data.has_galleries ? 'c-application-block__cta--will-expand' : '' }">${ data.has_galleries ? '<span class="c-application-block__cta-text">View Application</span>' : '' }</p>
                </div>

                <div class="c-application-block__footer">
                    <h2 class="u-beta c-application-block__title"><a class="c-application-block__title-link" href="${ data.permalink }">${ data.title }</a></h2>

                    ${ data.gallery.length > 1 ? `
                        <ul class="c-applications-block__btns">
                            <li class="c-applications-block__btn-item"><button type="button" class="o-arrow-btn c-application-block__btn js-application-block__gallery-previous-btn"><svg width="16" height="16" viewbox="0 0 100 100" class="o-arrow-btn__shape"><path d="${ data.arrow_shape }"></path></svg></button></li>
                            <li class="c-applications-block__btn-item c-applications-block__btn-item--next"><button type="button" class="o-arrow-btn c-application-block__btn js-application-block__gallery-next-btn"><svg width="16" height="16" viewbox="0 0 100 100" class="o-arrow-btn__shape"><path transform="translate(100, 100) rotate(180)" d="${ data.arrow_shape }"></path></svg></button></li>
                        </ul>
                    ` : `` }
                </div>

            </div>
        </div>
    `;
}
